import { UserFlags } from '@api/types/auth'

export { UserFlags }

/**
 * Check if a user has a specific flag enabled
 * @param flags The user's flags value (bitwise)
 * @param flag The flag to check for
 * @returns true if the flag is set
 */
export function hasUserFlag(flags: number | undefined, flag: UserFlags): boolean {
  if (flags === undefined || flags === null) return false
  return (flags & flag) !== 0
}

/**
 * Check if user can create silent adventures
 */
export function canCreateSilentAdventures(flags: number | undefined): boolean {
  return hasUserFlag(flags, UserFlags.CanCreateSilentAdventures)
}
